import { GroupEntityActionMenu } from '@internal/plugin-catalog-page-addons-react';
import React from 'react';

import { EntitySwitch, isKind } from '@backstage/plugin-catalog';

import { Grid } from '@material-ui/core';

import {
  isJiraTeamComponent,
  isPagerDutyTeamComponent,
  isSubscriptionResource,
} from '../entityUtils';
import { ComponentDetailsContent } from './ComponentDetailsContent';
import { JiraTeamActionContent } from './JiraTeamActionContent';
import { PagerDutyTeamActionContent } from './PagerDutyTeamActionContent';
import { RepositoryActionContent } from './RepositoryActionContent';
import { SubscriptionActionContent } from './SubscriptionActionContent';

export const ActionContent = (
  <Grid item md={12}>
    <EntitySwitch>
      <EntitySwitch.Case if={isKind('Repository')}>
        <RepositoryActionContent />
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={isKind('Group')}>
        <GroupEntityActionMenu />
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={isJiraTeamComponent}>
        <JiraTeamActionContent />
      </EntitySwitch.Case>
      <EntitySwitch.Case if={isPagerDutyTeamComponent}>
        <PagerDutyTeamActionContent />
      </EntitySwitch.Case>
      <EntitySwitch.Case if={isKind('Component')}>
        <ComponentDetailsContent />
      </EntitySwitch.Case>
    </EntitySwitch>
    <EntitySwitch>
      <EntitySwitch.Case if={isSubscriptionResource}>
        <SubscriptionActionContent />
      </EntitySwitch.Case>
    </EntitySwitch>
  </Grid>
);
